import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Reaction.css";

const Reaction = () => {

  const navigate = useNavigate();

  const initialForm = () => ({
    name: "",
    email: localStorage.getItem("rg_email") || "",
    phone: localStorage.getItem("rg_phone") || "",
    age: "",
  });
  const [loading, setLoading] = useState(false);
  const [formData] = useState(initialForm);

  const [circleColor, setCircleColor] = useState("red");
  const [reactionTime, setReactionTime] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [warningMsg, setWarningMsg] = useState("");

  const [clickCount, setClickCount] = useState(0);
  const [wrongClickCount, setWrongClickCount] = useState(0);

  const [results, setResults] = useState([]);
  const [countdown, setCountdown] = useState(null);
  const [greenClicked, setGreenClicked] = useState(false);
  const [currentWrongClicks, setCurrentWrongClicks] = useState(0);
  const [avgReaction, setAvgReaction] = useState(0);

  const [page, setPage] = useState("game");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* START GAME */

  const startGame = () => {

    setCircleColor("red");
    setCountdown(null);
    setGreenClicked(false);

    setTimeout(() => {

      setCircleColor("green");
      setStartTime(performance.now());

    }, Math.random() * 2000 + 1000);

  };

  useEffect(() => {
    startGame();
  }, []);

  /* CLICK */

 const handleCircleClick = () => {

  if (circleColor === "green" && startTime && !greenClicked) {

    setGreenClicked(true);

    const endTime = performance.now();
    const timeTaken = ((endTime - startTime) / 1000).toFixed(3);

    setReactionTime(timeTaken);
    setClickCount(prev => prev + 1);

    // 🔥 SAVE WITH wrongClicks per attempt
    setResults(prev => [
      ...prev,
      {
        result: Number(timeTaken),
        wrongClicks: currentWrongClicks
      }
    ]);

    // reset for next attempt
    setCurrentWrongClicks(0);

    setCountdown(5);

  } else {

    // 🔥 increment only current attempt wrong clicks
    setWrongClickCount(prev => prev + 1);
    setCurrentWrongClicks(prev => prev + 1);

  }

};
  /* SAVE DATA (NEW API) */

  const saveGameData = useCallback(async () => {
  try {

    const res = await axios.post("/api/reaction-save", {
      email: formData.email,
      phone: formData.phone,
      results,
      wrongClicks: wrongClickCount
    });

    setAvgReaction(Math.round(res.data.averageReaction * 1000));

    // 🔥 ADD THIS
    if (res.data.warning) {
      setWarningMsg(res.data.warning);
    }

  } catch (error) {
    console.error("Save error:", error.response?.data || error.message);
  }
}, [formData, results, wrongClickCount]);
  /* COUNTDOWN */

  useEffect(() => {

    if (countdown !== null && countdown > 0) {

      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);

    } else if (countdown === 0) {

      setCircleColor("red");

      if (clickCount < 5) {

        startGame();

      } else {

        setPage("result");
        saveGameData();

      }

    }

  }, [countdown, clickCount, saveGameData]);

  /* EXIT */

 

  return (

    <div className="containerr">

      {/* GAME */}

      {page === "game" && (

        <div className="game-containerr">

          <div
            className={`circler ${circleColor}`}
            onClick={handleCircleClick}
          ></div>

          <p className="reaction-timer">
            Reaction Time: {Math.round(reactionTime * 1000)} ms
          </p>

          {countdown !== null && (
            <p className="countdownr">
              Next Round: {countdown}
            </p>
          )}

          <p className="wrong-clickr">
            Wrong Clicks: {wrongClickCount}
          </p>

        </div>

      )}

      {/* RESULT */}

    {page === "result" && (() => {

      const avgMs = avgReaction;

      const ELITE = 190;
      const gap = avgMs - ELITE;
      const percent = Math.abs(Math.round((gap / ELITE) * 100));
      const isBetter = avgMs <= ELITE;

      return (

        <div className="result-wrapper">

          <div className="result-card">

            <p className="tag">REACTION SPEED RESULT</p>

            <h1 className="title">Your Reaction Speed</h1>

            <p className="subtext">
              A quick read on where you are right now — clear, personal,
              and easy to act on.
            </p>

            <h2 className="main-score">{avgMs} ms</h2>

            <p className="baseline">Your baseline</p>

            {/* STATS */}
            <div className="stats-row">
              <div className="stat-box">
                <p>Elite Players Average</p>
                <h3 className="text-green">190 ms</h3>
              </div>

              <div className="stat-box">
                <p>Your Gap</p>
                <h3 className="text-red">{gap} ms</h3>
              </div>
            </div>

            {/* COMPARE */}
            <div className="compare-box">

              <h3>How you compare</h3>

              {/* YOU */}
              <div className="bar-row">
                <span className="label">You</span>

                <div className="bar">
                  <div
                    className="fill yellow"
                    style={{ width: `${(avgMs / 400) * 100}%` }}
                  ></div>
                </div>

                <span className="value">{avgMs}</span>
              </div>

              {/* ELITE */}
              <div className="bar-row">
                <span className="label">Elite</span>

                <div className="bar">
                  <div
                    className="fill green"
                    style={{ width: `${(ELITE / 400) * 100}%` }}
                  ></div>
                </div>

                <span className="value">{ELITE}</span>
              </div>

              <p className="compare-text">
                You are reacting <b>{percent}% slower</b> than elite cricketers right now. 
                This gap is exactly what structured training can work on over time.
              </p>

            </div>
            {/* NEXT STEP */}
              <div className="next-step">
                <b>Next step:</b> Check your email for your detailed report and transformation roadmap.
              </div>

              {/* TIP BOX */}
              <div className="tip-box">
                ✍️ Faster reactions help with earlier pickup, cleaner decisions,
                and better timing.
              </div>
               <button
                  className="cta-btn"
                  disabled={loading}
                  onClick={async () => {
                    try {
                      setLoading(true);

                      await axios.post("/api/send-report", {
                        name: formData.name,
                        email: formData.email,
                        results,
                        avgReaction
                      });

                      navigate("/report-processing");

                    } catch (err) {
                      console.error(err);
                      alert("Failed to send report. Try again.");
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  {loading ? "Sending Report..." : "Continue to get detailed report →"}
                </button>
                          
          </div>
                

        </div>
           
      );

    })()}
    </div>

  );

};

export default Reaction;